import type { AsphaltShaderMode } from '../track/TrackRenderer';
import type { TerrainShaderMode } from '../render/Terrain';
import type { BakedSurfaceAssets } from '../render/BakedSurfaceAssets';

export function resolveTerrainShaderMode(params: URLSearchParams, bakedSurfaceAssets: BakedSurfaceAssets | null): TerrainShaderMode {
  const raw = (params.get('terrainShader') ?? params.get('terrainMaterial') ?? '').trim().toLowerCase();
  if ((raw === 'bakedpbr' || raw === 'pbr' || raw === 'baked') && bakedSurfaceAssets?.terrain) return 'bakedPbr';
  if (raw === 'detailed' || raw === 'procedural') return 'detailed';
  if (raw === 'fast' || raw === 'cheap' || raw === 'basic') return 'fast';
  if (bakedSurfaceAssets?.terrain) return 'bakedPbr';
  return 'detailed';
}

export function resolveAsphaltShaderMode(params: URLSearchParams, bakedSurfaceAssets: BakedSurfaceAssets | null): AsphaltShaderMode {
  const raw = (params.get('asphaltShader') ?? params.get('trackShader') ?? '').trim().toLowerCase();
  if ((raw === 'bakedpbr' || raw === 'pbr' || raw === 'baked') && bakedSurfaceAssets?.asphalt) return 'bakedPbr';
  if (raw === 'detailed' || raw === 'procedural') return 'detailed';
  if (raw === 'fast' || raw === 'cheap' || raw === 'basic') return 'fast';
  if (bakedSurfaceAssets?.asphalt) return 'bakedPbr';
  return 'detailed';
}

export function resolveAsphaltLiveDetail(params: URLSearchParams): boolean {
  const raw = (params.get('asphaltLiveDetail') ?? params.get('trackLiveDetail') ?? '').trim().toLowerCase();
  if (raw === 'on' || raw === 'true' || raw === '1' || raw === 'live') return true;
  if (raw === 'off' || raw === 'false' || raw === '0' || raw === 'baked') return false;
  return false;
}

export function resolveVolumetricCloudsEnabled(
  params: URLSearchParams,
  opts: { webgpu: boolean; mobile: boolean },
): boolean {
  if (!opts.webgpu || opts.mobile) return false;
  const hasFlag = params.has('volumetricClouds') || params.has('cloudDome');
  if (!hasFlag) return false;
  const raw = (params.get('volumetricClouds') ?? params.get('cloudDome') ?? '').trim().toLowerCase();
  return raw === '' || raw === 'on' || raw === 'true' || raw === '1';
}
